"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _text = require("@mmc/text");
var _reactRedux = require("react-redux");
var _actions = require("../../actions");
var _additionalEquipmentUi = _interopRequireDefault(require("./additional-equipment-ui/additional-equipment-ui"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function AdditionalEquipment(props) {
  var selectedModelCode = props.model,
    market = props.market,
    _props$data = props.data,
    _props$data$equipment = _props$data.equipmentList,
    equipmentList = _props$data$equipment === void 0 ? [] : _props$data$equipment,
    title = _props$data.headingText.title,
    _props$data$carousel = _props$data.carousel,
    carousel = _props$data$carousel === void 0 ? {} : _props$data$carousel,
    disclaimer = _props$data.disclaimer,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? {} : _props$theme,
    addPriceDisclaimer = props.addPriceDisclaimer,
    priceDisclaimerId = props.priceDisclaimerId,
    disclaimerData = props.disclaimerData,
    direction = props.direction,
    dispatch = props.dispatch;
  (0, _react.useEffect)(function () {
    if (!selectedModelCode && equipmentList.length) {
      dispatch((0, _actions.setModel)(equipmentList[0].code));
    }
  }, []);
  var onEquipmentOptionSelected = function onEquipmentOptionSelected(selectedModelCodeFromTrimLine) {
    dispatch((0, _actions.setModel)(selectedModelCodeFromTrimLine));
  };
  return /*#__PURE__*/_react["default"].createElement(_additionalEquipmentUi["default"], {
    selectedModelCode: selectedModelCode,
    equipmentList: equipmentList,
    title: title,
    theme: theme,
    carousel: carousel,
    disclaimerData: disclaimerData,
    addPriceDisclaimer: addPriceDisclaimer,
    priceDisclaimerId: priceDisclaimerId,
    direction: direction,
    onEquipmentOptionSelected: onEquipmentOptionSelected,
    disclaimer: disclaimer,
    market: market
  });
}
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    model: state.model.value,
    transmissionType: state.transmissionType.value,
    theme: props.theme,
    data: props.data
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(AdditionalEquipment);